// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading_tIclQ","loader":"loader_2PETs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/initializer/styles.scss
// module id = 439
// module chunks = 1